var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":_vm.confirmDelete}},[(_vm.isLoading)?_c('b-spinner',{attrs:{"small":""}}):[_vm._t("default",[_c('feather-icon',{attrs:{"icon":"Trash2Icon"}})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }